import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "region-filter" }
const _hoisted_2 = { class: "region-filter__inner-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "region-filter__head__title" }, "Search by Region", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SmartStatusRegionfilterMenu = _resolveComponent("SmartStatusRegionfilterMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["region-filter__head d-flex flex-row justify-content-between align-items-center", { open: _ctx.isOpen }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleOpen()))
      }, [
        _hoisted_3,
        _createVNode(_component_font_awesome_icon, {
          icon: "chevron-down",
          class: "region-filter__head__icon"
        })
      ], 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["region-filter__menu d-flex flex-column", { open: _ctx.isOpen }])
    }, [
      _createVNode(_component_SmartStatusRegionfilterMenu, { region: _ctx.nzRegion }, null, 8, ["region"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regionStore.getRegions, (region) => {
        return (_openBlock(), _createBlock(_component_SmartStatusRegionfilterMenu, {
          key: region.unitCode,
          region: region
        }, null, 8, ["region"]))
      }), 128))
    ], 2)
  ]))
}